/**
 * VortexCommandCentre — Skipper/Navigator persona showcase.
 *
 * Auto-cycling walkthrough of 8 Vortex capabilities from a sailor's perspective.
 * Demonstrates: model disagreement, ensemble competition, calibration,
 * nowcasting, observation divergence, departure planning, confidence trends,
 * and validated accuracy.
 *
 * Route: /vortex/command-centre
 * Existing /vortex (VortexTerminal) is preserved — this is a new view.
 */
import { CommandCentreBase } from '../shared/CommandCentreBase';
import { SCENARIOS, CYCLE_DURATION_MS } from '../../data/vortex-command-centre-data';

export const VortexCommandCentre = () => (
  <CommandCentreBase
    config={{
      scenarios: SCENARIOS,
      cycleDurationMs: CYCLE_DURATION_MS,
      productName: 'Vortex',
      productLabel: 'Vortex Command Centre',
      heroTitle: 'Navigator Co-Pilot',
      heroSubtitle: 'Calibrated marine intelligence that earns your trust. Watch Vortex work through real sailing scenarios — from departure planning to post-race analysis.',
      backLabel: '← Kempion',
      backPath: '/',
      terminalLabel: '→ Try the interactive terminal',
    }}
  />
);
